<template>
  <div class="app-container">

    <div class="sidebar" :class="{ 'sidebar--closed': !sidebarOpen }">
      <div class="sidebar__header">
        <h2 class="sidebar__title">Components</h2>
      </div>
      <nav class="sidebar__nav">
        <template v-for="(comps, section) in groups" :key="section">
          <div class="sidebar__section">
            <div class="sidebar__section-title">{{ section }}</div>
            <button
                v-for="comp in comps"
                :key="comp.id"
                @click="selectComponent(comp.id)"
                class="sidebar__item"
                :class="{ 'sidebar__item--active': activeComponent === comp.id }"
            >
              <span class="sidebar__item-icon">{{ comp.icon }}</span>
              <span class="sidebar__item-name">{{ comp.name }}</span>
              <span v-if="activeComponent === comp.id" class="sidebar__item-chevron">›</span>
            </button>
          </div>
        </template>
      </nav>
    </div>

    <div class="main">
			<AppHeader/>

<!--      <div class="header">-->
<!--        <button @click="toggleSidebar" class="header__toggle">-->
<!--          <span v-if="sidebarOpen">✕</span>-->
<!--          <span v-else>☰</span>-->
<!--        </button>-->
<!--        <div class="header__search-container">-->
<!--          <input-->
<!--              v-model="searchQuery"-->
<!--              type="text"-->
<!--              placeholder="Search components..."-->
<!--              class="header__search"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->

      <!-- Content Area -->
      <div class="content">

        <!-- Overview -->
        <template v-if="activeComponent === 'overview'">
<!--          <div class="content__section">-->
<!--            <h1 class="content__title">Component Library</h1>-->
<!--            <OverviewSample/>-->
<!--          </div>-->
        </template>

        <!-- Inputs -->
        <template v-else-if="activeComponent === 'inputs'">
          <div class="content__section">
            <h1 class="content__title">Input Fields</h1>
            <InputsSample/>
          </div>
        </template>

        <!-- Checkboxes -->
        <template v-else-if="activeComponent === 'checkboxes'">
          <div class="content__section">
            <h1 class="content__title">Checkboxes</h1>
            <CheckboxesSample/>
          </div>
        </template>

        <!-- Buttons -->
        <template v-else-if="activeComponent === 'buttons'">
          <div class="content__section">
            <h1 class="content__title">Buttons & ButtonsGroup</h1>
            <ButtonsSample/>
          </div>
        </template>

        <!-- Toggles & Switches -->
        <template v-else-if="activeComponent === 'toggles'">
          <div class="content__section">
            <h1 class="content__title">Toggles & Switches</h1>
            <TogglesSample/>
          </div>
        </template>

        <!-- Select -->
        <template v-else-if="activeComponent === 'select'">
          <div class="content__section">
            <h1 class="content__title">Select Components</h1>
            <SelectSemple/>
          </div>
        </template>

        <!-- Tabs -->
        <template v-else-if="activeComponent === 'tabs'">
          <div class="content__section">
            <h1 class="content__title">Tabs</h1>
            <TabsSample/>
          </div>
        </template>

        <!-- Card -->
        <template v-else-if="activeComponent === 'card'">
          <div class="content__section">
            <h1 class="content__title">Card Component</h1>
            <CardSample/>
          </div>
        </template>

        <!-- Icon -->
        <template v-else-if="activeComponent === 'icon'">
          <div class="content__section">
            <h1 class="content__title">Icon Component</h1>
            <IconSample/>
          </div>
        </template>

        <template v-else-if="activeComponent === 'new-data-grid-lvl1'">
          <div class="content__section">
            <h1 class="content__title">NewDataGrid 1 уровень</h1>
            <VDataGridNew1lvl/>
          </div>
        </template>

        <template v-else-if="activeComponent === 'new-data-grid-lvl2'">
          <div class="content__section">
            <h1 class="content__title">NewDataGrid 2 уровня</h1>
            <VDataGridNew2lvl/>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="@/lib/pages/MainPage.scss"></style>

<script lang="ts">
import OverviewSample   from "@/lib/pages/samples/OverviewSample.vue";
import ButtonsSample    from "@/lib/pages/samples/ButtonsSample.vue";
import CardSample       from "@/lib/pages/samples/CardSample.vue";
import CheckboxesSample from "@/lib/pages/samples/CheckboxesSample.vue";
import IconSample       from "@/lib/pages/samples/IconSample.vue";
import InputsSample     from "@/lib/pages/samples/InputsSample.vue";
import SelectSemple     from "@/lib/pages/samples/SelectSemple.vue";
import TabsSample       from "@/lib/pages/samples/TabsSample.vue";
import TogglesSample    from "@/lib/pages/samples/TogglesSample.vue";

import VDataGridNew1lvl     from '@/lib/components/VDataGridV2/examples/ExampleUsage1lvl.vue';
import VDataGridNew2lvl 		from '@/lib/components/VDataGridV2/examples/ExampleUsage2lvl.vue';

import AppHeader            from '@/lib/components/AppHeader/AppHeader.vue';

import { componentsMenu } from "@/lib/pages/Config";

export default defineComponent({
  name: 'LibPage',

  components: {
    OverviewSample,
    ButtonsSample,
    CardSample,
    CheckboxesSample,
    IconSample,
    InputsSample,
    SelectSemple,
    TabsSample,
    TogglesSample,
    VDataGridNew1lvl,
    VDataGridNew2lvl,
		AppHeader
  },

  data() {
    return {
      sidebarOpen: true,
      activeComponent: 'overview',
      searchQuery: '',
      componentsMenu,
    };
  },

  computed: {
    // Фильтрованные компоненты по поиску
    filteredComponents() {
      if (!this.searchQuery.trim()) {
        return this.componentsMenu;
      }

      const query = this.searchQuery.toLowerCase();
      return this.componentsMenu.filter(comp =>
          comp.name.toLowerCase().includes(query) ||
          comp.section.toLowerCase().includes(query)
      );
    },

    // Группировка по секциям с учетом фильтра
    groups() {
      const result = {};
      this.filteredComponents.forEach(comp => {
        if (!result[comp.section]) {
          result[comp.section] = [];
        }
        result[comp.section].push(comp);
      });
      return result;
    },
  },

  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },

    selectComponent(id: string) {
      this.activeComponent = id;
    },
  },
});
</script>
